import { useMemo } from "react";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { getRiskLevel } from "../../utilities/risk-levels";
import { StatusTag } from "@chr/eds-react";
import { Box, chipClasses, svgIconClasses } from "@mui/material";
import customTheme from "../theme-provider/customTheme";

interface RiskLevelProps {
  riskLevel: string;
}

export function RiskLevel({ riskLevel }: RiskLevelProps) {
  const translate = useTranslation();
  const { label, severity } = getRiskLevel(riskLevel);
  const { palette } = customTheme();

  const urgentStyle = useMemo(() => ({
    [`.${chipClasses.label}, .${chipClasses.icon}.${svgIconClasses.root}`]: {
      color: `${palette.early?.dark} !important`,
    }
  }), [palette]);

  return (
    <Box
      sx={{ ...(severity === 'urgent' ? urgentStyle : {}) }}
    >
      <StatusTag
        label={translate(label)}
        severity={severity}
        labelSize="medium"
        size="spacious"
        data-testid="risklevel-header"
        icon
      />
    </Box>
  );
}
